module.exports = __webpack_public_path__ + "img/rank-header.2f1fb9f2.svg";